export const ZohoDetailedFeatures = [
    {
        "tab_heading":"CRM / Lead Management",
        "tab_info":[
            {
                "name":"Lead Management",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"1-click Property portals integration - auto lead capture",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Configurable Pipeline Management",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Custom Fields",
                "realtor":"Yes",
                "type":"Only in Higher Plans"
            },
            {
                "name":"Team Management",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Full Hierarchy Management",
                "realtor":"Yes",
                "type":"Yes"
            }
        ]
    },
    {
        "tab_heading":"Omnichannel Communication",
        "tab_info":[
            {
                "name":"Integrated Cloud telephony with IVR, complex routing, intelligent sticky routing",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"International & India Support Across Key Telephony providers",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Toll Free Numbers Availability - India & International",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Full Call Centre Software",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Support for On-Premise Telephony Set up",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Integrated Email Communication with Delivery, Open, Click Tracking",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Integrated SMS & Short-code Support",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Integrated WhatsApp For Business Support (with full Automation like MakeMyTrip)*",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Integrations with Live Chat Software",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Integrations with FB Messenger",
                "realtor":"Partial",
                "type":"3rd Party"
            },
            {
                "name":"Integrations with Chat bots",
                "realtor":"Partial",
                "type":"3rd Party"
            },
            {
                "name":"Automated Outbound Dialer",
                "realtor":"Y (upgrade possible for multiple call center spots)",
                "type":"3rd Party"
            }
        ]
    },
    {
        "tab_heading":"Sales Automation",
        "tab_info":[
            {
                "name":"Workflow Management - Automate lead & sales management",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Fully configurable Lead Scoring Algo developed with 10 years of industry Experience",
                "realtor":"Yes",
                "type":"Partial"
            },
            {
                "name":"Intelligent Lead Routing - based on Project, Team, Geo, Campaign, Source, sub source",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Sales Targets & Reports",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Asset management - Images, brochures, quotes, files",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Automated Responders - Email + SMS + WhatsApp",
                "realtor":"Yes",
                "type":"Y (No WhatsApp)"
            },
            {
                "name":"Booking Form with Support for Agreement + Brokerage Calculations",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Customizable sales UI - Forms, Booking form, etc",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Automated click to call function",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Fully Integrated IVR",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Site Visit Feedback Forms",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Insta Connect - For Instant Auto connected Call back to Customers",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Escalation Matrix & Risk Identification",
                "realtor":"Yes",
                "type":"Yes"
            }
        ]
    },
    {
        "tab_heading":"Channel Partner Management (Channel Partner Module)",
        "tab_info":[
            {
                "name":"Full Support for Channel Partner Onboarding",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Broadcast Messages & Offers to Partners",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Partner Lead Tracking",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Allow Partners to take bookings, with cheque/payment collections",
                "realtor":"Y (With IRIS)",
                "type":"3rd Party"
            }
        ]
    },
    {
        "tab_heading":"Negotiation & Price Quote Management",
        "tab_info":[
            {
                "name":"Create & Track Price Quotes",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Schemes & Discounts",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Approval Workflow for Discounts",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Payment Schedule & Cost Sheet Calculator",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"PDF Generator for Payment Schedule & Cost Calculator",
                "realtor":"Yes",
                "type":"3rd Party"
            }
        ]
    },
    {
        "tab_heading":"Marketing Automation (Marketing Module)",
        "tab_info":[
            {
                "name":"Campaign Management",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"ROI Calculations",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Campaign Targets & Tracking/Reports",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Connected Facebook Adverts Tracking - Auto CPL calculations & Dashboards",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Connected Awards Tracking - Auto CPL calculations & Dashboards",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Offline Budget & CPL Tracking - Outdoor, Print, BTL, Portals",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Drip Marketing",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Automated tracking of website, live chat, and any lead input channel",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Missed Calls Campaigns",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Short Code Integration",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Outbound Call Campaigns",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Completely customizable Website builder - with free templates - comes with a free project microsite",
                "realtor":"No",
                "type":"Yes"
            },
            {
                "name":"Auto Integrates with Google Analytics and e-commerce",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Bulk Email Marketing",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Bulk SMS Marketing",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Facebook Lead Generation Ads - Auto Lead Capture",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Look Alike Audience Management with Awards & Facebook",
                "realtor":"Yes",
                "type":"3rd Party"
            }
        ]
    },
    {
        "tab_heading":"Product & Inventory",
        "tab_info":[
            {
                "name":"Inventory management - projects, towers, configurations and units",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Costs & Cost Sheet Calculator at Unit Level",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Inventory Pipeline Management - Blocking of Premium Inventory",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Support for Sale, Resale, Rental Inventory",
                "realtor":"Yes",
                "type":"3rd Party"
            },
            {
                "name":"Integration with leading ERPs (SAP, Dynamics, Farvision)",
                "realtor":"Yes",
                "type":"3rd Party"
            }
        ]
    },
    {
        "tab_heading":"Post Sales (Post Sales Module)",
        "tab_info":[
            {
                "name":"Complete Demand Letter Generation",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Payment Reminders",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Fully configurable payment schedules & Ad-Hoc Costs",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Cancellations & Upgrades",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Manage Parking Inventory",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Booking to Agreement to Possession Automation & Tracking",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Ledger & Outstanding",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Interest Calculations & Demand",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Receipts & Payment Collection",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Integrated Post Sales Communication - Email, SMS, WhatsApp",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Integrated Workflow Automation",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Inventory Movement Report",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Recovery & Ageing Report",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Risk Identification & Automated Escalations",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Reporting & Dashboards",
        "tab_info":[
            {
                "name":"Sales Reports",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Lead Pipeline Reports",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Calling & Call Centre Reports",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Funnel and Cohort analysis",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Analytics platform with funnel customer journey mapping and real time reporting",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Lead Re-Engagement reports",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Reports for online, offline, by channel (google, fb, print, outdoor), by medium (phone, email, website, etc)",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Full Visitor Behaviour Analytics",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Customized MIS Reports",
                "realtor":"Yes",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Customer Management (IRIS)",
        "tab_info":[
            {
                "name":"Customer Access & Online Interface",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Online Bookings, Schemes & Discounts",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Referral & Loyalty Program",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Online Payments",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Project Launch & EOI Support",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Channel Partner Management",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Channel Partners can take bookings & collect Payments",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Cancellation & Swap Support",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Ticketing Support for Customers",
                "realtor":"Partial",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Mobile App (No Extra Charges)",
        "tab_info":[
            {
                "name":"Sales Management Android & iOS App",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"GPS Tracking",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Inventory Management Support",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"OTP Based Meeting Verification",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"GPS Based Meeting Verification",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Offline Call Tracking with Recording",
                "realtor":"Y (Recording works on selected Android handsets)",
                "type":"No"
            }
        ]
    },
    {
        "tab_heading":"Data Security",
        "tab_info":[
            {
                "name":"ISO 27001 Certified Data Security & Compliance",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"Camouflaged Communication - No exposure of customer's phone/email data to anyone except the admin",
                "realtor":"Yes",
                "type":"No"
            },
            {
                "name":"Full VAPT Compliance",
                "realtor":"Yes",
                "type":"Yes"
            },
            {
                "name":"GDPR Compliance",
                "realtor":"Under Works",
                "type":"Yes"
            },
            {
                "name":"Data security - Complete Sandboxed and Encrypted data on the Cloud",
                "realtor":"Yes",
                "type":"Yes"
            }
        ]
    }
];
export default ZohoDetailedFeatures;
